<template>
  <div class="main" :style="{width: contentWidth + 'rem'}" @click="contentClick" v-clickoutside="outFun">
    <div v-if="showShare" :class="unfold?'block':'block left_over'" @click="shareHandle()">
      <i class="icon share"></i>
      <h4 v-if="unfold" class="name">分享</h4>
    </div>
    <div v-if="showOrderList" :class="unfold?'block':'block left_over'" @click="toListView()">
      <i class="icon list"></i>
      <h4 v-if="unfold" class="name">我的订单</h4>
    </div>
    <template v-if="showCustomerService">
      <div v-if="igc_from !== 'miniProgram'" :class="unfold?'block':'block left_over'" v-fastclick="()=>{imClick()}">
        <i class="icon im"></i>
        <h4 v-if="unfold" class="name">咨询客服</h4>
      </div>
    </template>
  </div>
</template>

<script>
import { getUser } from '@utils/auth';
import { env, LogTrack, JS2Native } from '@utils';
import { jumpToService } from '@utils/common';

export default {
  props: {
    showOrder: {
      type: Boolean,
      default() {
        return true;
      }
    },
    goodsDetail: {
      type: Object
    },
    shareData: {
      type: Object
    },
    ptInfo: {
      type: Object,
      default() {
        return {};
      }
    },
    userReallyOnline: Boolean,
    isShowShare: {
      type: [Boolean, Number],
      default() {
        return true;
      }
    },
  },
  data() {
    let {
      itemid,
      igc_from,
      ptFlag
    } = this.$route.query;
    if (igc_from === 'xxx') { igc_from = undefined }

    return {
      itemid,
      unfold: false,
      contentWidth: null,
      unfoldTimeOutMark: null,
      timeOutMark: null,
      userInfo: null,
      igc_from,
      ptFlag,
      showCustomerService: true,
    };
  },
  computed: {
    showOrderList() {
      return !env.isApp && this.showOrder;
    },
    showShare() {
      return env.isApp && this.showOrder && this.isShowShare && !env.isHarmonyApp;
    }
  },
  directives: {
    clickoutside: {
      bind(el, binding, vnode) {
        function documentHandler(e) {
          if (el.contains(e.target)) {
            return false;
          }
          if (binding.expression) {
            binding.value(e);
          }
        }

        el.__vueClickOutside__ = documentHandler;
        document.addEventListener('click', documentHandler);
      },
      update() {
      },
      unbind(el, binding) {
        document.removeEventListener('click', el.__vueClickOutside__);
        delete el.__vueClickOutside__;
      }
    }
  },
  created() {

    // window.addEventListener('beforeunload', () => {
    //   sessionStorage.removeItem('imInit');
    // });
    // let imInit = sessionStorage.getItem('imInit');
    // this.contentWidth = this.showOrderList || this.showShare ? 0.6 : 0.4;
    // this.userInfo = getUser();
    // if (!imInit&&this.userInfo) {
    //   this.initIM();
    //   sessionStorage.setItem('imInit', true);
    // }

    if (env.isWeChat) {
      wx.miniProgram.getEnv(res => {
        if (res.miniprogram) {
          this.showCustomerService = false;
        } else {
          this.initIM();
        }
      });
    } else {
      this.initIM();
    }
    this.contentWidth = this.showOrderList || this.showShare ? 0.6 : 0.4;
  },
  methods: {
    initIM() {
      this.userInfo = getUser();
      if (env.isHarmonyApp) {
        return;
      }

      if (this.userInfo && this.igc_from !== 'miniProgram' && this.$route.query.webchat !== '0') {
        window.qimoClientId = {
          userId: `${JSON.parse(localStorage.getItem('IGetCool-USER-Info')).uid}`, // 自定义用户的唯一id，不能传空字符串、null、中文，id由字母大小写、数字及'-'和 '_'组成
          priority: false, // 是否优先进线设置，非必填，值为boolean类型的true或false
          nickName: `${JSON.parse(localStorage.getItem('IGetCool-USER-Info')).phone}`, // 自定义用户昵称，定义用户昵称则userId必传
          customField: { // 扩展字段，json对象，对象中的key-value都自定义
            '手机号': `${JSON.parse(localStorage.getItem('IGetCool-USER-Info')).phone}`,
            'uid': `${JSON.parse(localStorage.getItem('IGetCool-USER-Info')).uid}`,
            'channel': this.channel
          }
        };
        this.$nextTick(() => {
          if (document.querySelector('#talk_tool_qimo')) { return }
          let secScript = document.createElement('script');
          secScript.setAttribute('type', 'text/javascript');
          secScript.setAttribute('id', 'talk_tool_qimo');
          secScript.setAttribute('src', 'https://webchat.7moor.com/javascripts/7moorInit.js?accessId=7b3019f0-c57b-11e9-9f01-8969b6bbf727&autoShow=false&language=ZHCN');
          secScript.setAttribute('async', 'async');
          document.body.insertBefore(secScript, document.body.lastChild);
        });
      }
    },
    outFun() {
      if (this.unfold) {
        this.unfold = false;
        this.contentWidth = this.showOrderList || this.showShare ? 0.6 : 0.4;
        clearTimeout(this.unfoldTimeOutMark);
        clearTimeout(this.timeOutMark);
      }
    },
    contentClick(e) {
      if (!this.unfold) {
        this.$emit('clickTool');
        this.contentWidth = this.showOrderList ? 2.1 : this.showShare ? 1.9 : 1.1;
        if (!this.showCustomerService && this.contentWidth > 1.1) {
          this.contentWidth = this.contentWidth - 0.8;
        }
        this.unfoldTimeOutMark = setTimeout(() => {
          this.unfold = true;
        }, 500);
        this.timeOutMark = setTimeout(() => {
          this.unfold = false;
          this.contentWidth = this.showOrderList || this.showShare ? 0.6 : 0.4;
        }, 3000);
      }
    },
    shareHandle() {
      if (!this.unfold) { return }
      let uid = null;
      let data = getUser();
      if (data) {
        uid = JSON.parse(data).uid;
      }

      // 有反馈在app分享出来的地址是http的，不易复现，将协议头写死
      const locationOrigin = 'https://' + window.location.host;
      const igcFrom = this.igc_from ? `&igc_from=${this.igc_from}` : '';

      const goodsMsg = this.goodsDetail;
      let shareMsg;
      if (this.ptFlag) {
        let title = `《${goodsMsg.name}》课程拼团啦`;
        let des = '拼团活动太划算了，找伙伴们一起学习吧！';
        if (this.userReallyOnline) {
          shareMsg = {
            title: this.ptInfo.ptActivityBasicRespDto.goodsShareTitle || title,
            coverImg: this.ptInfo.ptActivityBasicRespDto.goodsShareAppPic || 'https://coolcdn.igetcool.com/p/2020/10/613f787d463b9dc5032fa3919ba18f80.png?_200x200.png',
            intro: this.ptInfo.ptActivityBasicRespDto.goodsShareDesc || des,
            url: `${locationOrigin}/mall/course?itemid=${this.itemid}&ptFlag=${this.ptFlag}${igcFrom}`
          };
        } else {
          shareMsg = {
            title: title,
            coverImg: 'https://coolcdn.igetcool.com/p/2020/10/613f787d463b9dc5032fa3919ba18f80.png?_200x200.png',
            intro: des,
            url: `${locationOrigin}/mall/course?itemid=${this.itemid}&ptFlag=${this.ptFlag}${igcFrom}`
          };
        }
      } else if (this.shareData?.shareTitle) {
        shareMsg = {
          title: this.shareData.shareTitle,
          coverImg: this.shareData.shareCover,
          intro: this.shareData.shareIntro,
          url: this.shareData.shareUrl,
        };
      } else {
        shareMsg = {
          title: goodsMsg.basicAndGuideShareResDTO
            ? goodsMsg.basicAndGuideShareResDTO.shareTitle
            : `分享|${goodsMsg.name}`,
          coverImg: goodsMsg.basicAndGuideShareResDTO
            ? goodsMsg.basicAndGuideShareResDTO.shareImageUrl
            : goodsMsg.coverImg,
          intro: goodsMsg.basicAndGuideShareResDTO
            ? goodsMsg.basicAndGuideShareResDTO.shareDescribe
            : '限时特惠，即将开课，戳此立抢>>',
          url: `${locationOrigin}${location.pathname}?itemid=${this.itemid}${igcFrom}${
            (this.goodsDetail.sellType === 4 || !uid) ? '' : '&instructor=' + uid
          }`
        };
      }
      JS2Native({
        name: 'webShare',
        params: {

          // 新版才有用
          shareType: 0,

          // 新版才有用
          showWindow: 0,
          channel: ['WXFRIEND', 'WXPYQ'],
          shareInfo: {
            shareTitle: shareMsg.title,
            shareCover: shareMsg.coverImg,
            shareIntro: shareMsg.intro,
            shareUrl: shareMsg.url,
            hostAndPath: location.origin + location.pathname
          },
          event: 'sndd_app_traffic'
        }
      });
    },
    toListView() {
      if (this.unfold) {
        this.$emit('goToOrder');
      }
      if (this.unfold) {
        let param =  this.itemid ? 'itemid=' + this.itemid + '&' : '';
        let url = `/mall/order/list?${param}igc_from=${this.igc_from}${this.loginTrackParams()}`;

        if (env.isWeChat) {
          location.href = url;
        } else {
          this.$router.push(url);
        }
      }
    },

    // 打开客服
    // @aigc:start 2024/07/26-17:02
    toIM() {
      if (env.isHarmonyApp) {
        jumpToService({ channel: this.igc_from });
        return;
      }
      qimoChatClick();
    },
    // @aigc:end 2024/07/26-17:02

    imClick() {
      if (this.unfold) {
        this.$emit('goToIM');
      }

      if (this.unfold) {
        if (this.userInfo) {
          this.toIM();
        } else {
          const search = location.search;
          const redirect = location.pathname;
          this.$router.replace({ path: `/mall/login${search ? `${search}&` : '?'}redirect=${redirect}${this.loginTrackParams(1)}` });
        }
      }
    },
    // 登陆页埋点使用， 用来判断是否是领券购、流程类型
    loginTrackParams(type) {
      let params = '';
      if (this.goodsDetail) {
        if (type == 1) {
          const search = location.search;
          !search.includes('sellType') && this.goodsDetail.sellType && (params += '&sellType=' + this.goodsDetail.sellType);
          !search.includes('couponUse') && this.goodsDetail.couponUse && (params += '&couponUse=' + (this.goodsDetail.couponUse ? 1 : 0));
        } else {
          this.goodsDetail.sellType && (params += '&sellType=' + this.goodsDetail.sellType);
          this.goodsDetail.couponUse && (params += '&couponUse=' + (this.goodsDetail.couponUse ? 1 : 0));
        }
      }
      return params;
    }
  },
  beforeDestroy() {
    clearTimeout(this.unfoldTimeOutMark);
    clearTimeout(this.timeOutMark);
  }
};
</script>

<style lang="stylus" scoped>
  *
    box-sizing border-box

  .main
    position fixed
    display flex
    align-items center
    right 0
    top 60px
    height .56rem
    padding 0 .04rem 0 .12rem
    background-color rgba(0, 0, 0, .4)
    border-radius 1rem 0 0 1rem
    transition width .5s
    -webkit-transition width .5s
    z-index 2000
    .block
      display flex
      flex-direction row
      align-items center

      &:not(:first-child)
        margin-left .12rem

      &.left_over
        &:not(:first-child)
          margin-left -.05rem !important

      .icon
        box-sizing border-box
        display inline-block
        width 24px
        height 24px
        background-size 16px 16px
        background-position center
        background-repeat no-repeat
        padding 6px
        border-radius 12px
        background-color white

        &.share
          background-image image-set(url(./images/mall_share_icon.png) 1x, url(./images/mall_share_icon@2x.png) 2x)
          background-image -webkit-image-set(url(./images/mall_share_icon.png) 1x, url(./images/mall_share_icon@2x.png) 2x)

        &.list
          background-image image-set(url(./images/h5_payment_icon_my_order.png) 1x, url(./images/h5_payment_icon_my_order@2x.png) 2x)
          background-image -webkit-image-set(url(./images/h5_payment_icon_my_order.png) 1x, url(./images/h5_payment_icon_my_order@2x.png) 2x)

        &.im
          background-image image-set(url(../../assets/images/icon/my_im_icon.png) 1x, url(../../assets/images/icon/my_im_icon@2x.png) 2x)
          background-image -webkit-image-set(url(../../assets/images/icon/my_im_icon.png) 1x, url(../../assets/images/icon/my_im_icon@2x.png) 2x)

      .name
        font-size 12px
        font-weight 500
        line-height 14px
        color white
        margin-left .1rem
</style>
